import React, { useEffect, useState } from 'react';
import useCookie from 'hooks/useCookie';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import logo from 'assets/icons/logo.svg';
import whiteLogo from 'assets/icons/logo_white.svg';
import { Dim, Icon, Img } from 'components';
import { selectLang } from 'lang';
import { Text } from 'styles';
import * as S from './HeaderStyle';

export function Header({ list, selectedLang, scrollPosition, setRef }) {
  const location = useLocation();
  const { setCookies } = useCookie();
  const navigate = useNavigate();
  const [open, setOpen] = useState();
  const [subOpen, setSubOpen] = useState();
  const [hover, setHover] = useState();

  // 하위 메뉴 이동: 다른 페이지면 인덱스 저장 후 이동, 같은 페이지면 URL이 안 바뀌어 페이지가 다시 스크롤하지 않으므로 직접 스크롤
  const moveSub = (sub, idx) => {
    const index = sub.index !== undefined ? sub.index : idx;
    sessionStorage.setItem('currentIndex', String(index));
    const samePage = location.pathname.replace(/\/+$/, '') === sub.path.replace(/\/+$/, '');
    if (samePage && setRef?.current?.[index]) {
      window.dispatchEvent(new Event('currentIndexChange')); // 왼쪽 nav(ScrollAside) 선택 표시 갱신
      setRef.current[index].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    } else {
      navigate(sub.path);
    }
  };

  return (
    <S.Container
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      $scrollPosition={scrollPosition}
      $sub={location.pathname !== '/'}
    >
      <S.Wrap>
        <Img
          src={((scrollPosition > 1 || open || hover || location.pathname !== '/') && logo) || whiteLogo}
          $width={140}
          height={46}
          $mWidth={92}
          $mHeight={30}
          alt="로고"
          $pointer
          onClick={() => {
            sessionStorage.removeItem('currentIndex');
            navigate('/');
          }}
        />
        <h1>주식회사 팜인</h1>
        <S.Nav>
          <h2>네비게이션 메뉴</h2>
          <S.MenuList>
            {list.map((item, index) => (
              <S.MenuListItem
                key={`item_${index}`}
                $count={item.sub.length}
                $scrollPosition={scrollPosition}
                $sub={location.pathname !== '/'}
                $active={
                  (location.pathname !== '/' && item.path.includes(location.pathname)) ||
                  (item.path.includes('community') && location.pathname.split('/')[1] === item.path.split('/')[1])
                }
              >
                <NavLink to={item.path} onClick={() => sessionStorage.removeItem(`currentIndex`)}>
                  <h3>{item.name}</h3>
                </NavLink>
                <ul>
                  {item.sub.map((sub, idx) => (
                    <li key={`sub_${idx}`}>
                      <NavLink
                        to={sub.path}
                        onClick={(e) => {
                          // Ctrl/Cmd/Shift/휠 클릭은 브라우저 기본 동작(새 탭 등) 유지
                          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
                          e.preventDefault();
                          moveSub(sub, idx);
                        }}
                      >
                        <h4>{sub.name}</h4>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </S.MenuListItem>
            ))}
          </S.MenuList>
          {/* 언어 변경 버튼  */}
          {/* <S.LangBox
          $scrollPosition={scrollPosition}
          $hover={hover}
          open={open}
          $main={window.location.pathname === '/'}
        >
          <div>
            <Icon name="language" $width={20} $height={20} $padding="2px" />
            <Text $type="h5">{selectedLang.label}</Text>
          </div>
          <div
            role="presentation"
            onClick={() =>
              setCookies('language', selectLang.filter((el) => el.value !== selectedLang.value)[0].value)
            }
          >
            <Text $type="b5">{selectLang.filter((el) => el.value !== selectedLang.value)[0].label}</Text>
          </div>
        </S.LangBox> */}
          <S.MoBox
            onClick={() => {
              setOpen(!open);
              setSubOpen();
            }}
          >
            <Icon name={(open && 'close') || 'menu'} $width={24} $height={24} $padding="0" />
          </S.MoBox>
        </S.Nav>
        {open && <Dim />}
        <S.MoContainer open={open}>
          <S.MoWrap>
            <S.MoList>
              {list.map((item, index) => (
                <S.MoListItem key={`item_${index}`} open={subOpen === index}>
                  <div role="presentation" onClick={() => setSubOpen(index !== subOpen ? index : null)}>
                    <Text
                      type={(subOpen === index && 'h5') || 'b5'}
                      $color={(subOpen === index && 'primary') || 'secondary800'}
                    >
                      {item.name}
                    </Text>
                    <Icon
                      name="arrow"
                      $transform={subOpen === index && 'rotate(-180deg)'}
                      $pathStroke={subOpen === index && 'primary'}
                      $strokeOpacity={subOpen === index && '1'}
                    />
                  </div>
                  <S.MoSubList $count={item.sub.length} open={subOpen === index}>
                    {item.sub.map((sub, idx) => (
                      <li
                        key={`sub_${idx}`}
                        onClick={() => {
                          moveSub(sub, idx);
                          setOpen();
                        }}
                      >
                        <Text $type="b7" style={{ lineHeight: 1 }} $color="secondary">
                          {sub.name}
                        </Text>
                      </li>
                    ))}
                  </S.MoSubList>
                </S.MoListItem>
              ))}
            </S.MoList>
          </S.MoWrap>
        </S.MoContainer>
      </S.Wrap>
    </S.Container>
  );
}
